import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Button, Modal, Alert } from 'reactstrap';
import { InputSelect } from '../Forms/Input';
import classNames from 'classnames';
import Loading from '../Loading';
import { BankTransferInstructions, VirtualAccountInstructions } from '../PageUserDashboard/TopUp';
import { convertToRupiah, hasError } from '../../utils';
import { FormFeedback } from '../Forms';
import {
  BANKTRANSFER,
  VIRTUALACCOUNT,
  CREDITCARD,
  BCA_VA,
  BNI_VA,
  PERMATA_VA,
  MANDIRI_VA
} from '../../constants/paymentMethods';

const ModalTopUp2 = props =>{
  const { amount, uniqueAmount, administrationFee, paymentMethod } = props;
  const totalAmount = parseInt(amount)+parseInt(uniqueAmount)+parseInt(administrationFee);
  // if(paymentMethod === 'bank_transfer'){
  //   totalAmount = parseInt(amount) + parseInt(uniqueAmount);
  // }
  // else if(paymentMethod === 'virtual_account'){
  //   totalAmount = parseInt(amount) + 5000;
  // }
  // else{
  //   totalAmount = parseInt(amount);
  // }
  const payment_method = [
    // {value: '', label:'Choose payment method...'},
    // {value: BANKTRANSFER, label:'Bank Transfer (ATM/Internet/Mobile Banking)'},
    {value: BCA_VA, label:'BCA (Virtual Account)'},
    {value: MANDIRI_VA, label:'MANDIRI (Virtual Account)'},
    {value: BNI_VA, label:'BNI (Virtual Account)'},
    {value: PERMATA_VA, label:'PERMATA (Virtual Account)'},
    {value: VIRTUALACCOUNT, label:'Other Virtual Account'},
    // {value: CREDITCARD, label:'Credit Card'}
  ];
  
  return(
    <Modal
      modalClassName="modal-topup"
      isOpen={props.isOpen}
      toggle={props.onToggle}
    >
      <div className="topup-header">
        <p>TOP UP</p>
      </div>
      <div className="topup-content">
        <div className="wrap-topup-amount">
          <div className="topup-amount">
            {/* <p>{this.props.amountTopup}</p> */}
            <p>{convertToRupiah(parseInt(totalAmount))}</p>
          </div>
        </div>
        <div className="text-desc4">
          <p>Select method of payments:</p>
        </div>
        <div className="dropdown-topup">
          <InputSelect
            name="paymentMethod"
            value={props.paymentMethod}
            onChange={props.onTextChange}
            options={payment_method}
            className={classNames({"is-invalid": hasError(props.error && props.error.errors, "payment_method")})}
          />
        </div>
        <div className="instruction-style">
          {
            props.paymentMethod === 'bank_transfer'?
            <BankTransferInstructions
            totalAmount={totalAmount}
            />:
            <VirtualAccountInstructions/>
          }
        </div>
        <div className="wrap-button-text">
          <Alert color="danger" isOpen={props.isAlertErrorOpen} toggle={props.onAlertErrorToggle}>
          {
            props.error&&props.error.status_code==403? 'Failed to top up. Please verify your account.' : 
            <strong>Failed. {props.errorMessage}</strong>
          }
          </Alert>
          <div className="topup-button2">
            {
              props.isSubmit || props.isRedirect?
                <Loading center/>
              :
                <Button
                  className={classNames("topup-content", {"btn": totalAmount>0, "btn2": totalAmount<=0})}
                  disabled={totalAmount<=0}
                  // onClick={() => props.onNextPage(3)}
                  onClick={props.onSubmit}
                >
                  Next
                </Button>
            }
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ModalTopUp2;
